import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export const isBadRequest = (response: HttpErrorResponse): boolean => {
  return response.status === HttpStatusCode.BadRequest;
};
